<template>
<div>
  <template v-if="nowTab === 1">
    <div class="flex flex-wrap justify-center">
      <template v-for="(plan, index) in config.plans">
        <div class="w-full mb-8 lg:mb-0 sm:w-1/2 lg:w-1/3" :key="index">
          <div class="priceTable__item shadow rounded-sm px-16 py-24 mx-4 lg:mb-0">
            <h3 class="text-center font-bold">{{ plan.name }}</h3>
            <div class="text-center">
              <div  class="text-blue mt-16 mb-32 font-bold">
                <template v-if="typeof plan.price === 'number'">
                  USD <span class="text-4xl font-bold">{{ plan.price | toThousands }}</span> / month
                </template>
                <template v-else>
                  <span class="text-2xl leading-2xl font-bold">{{ plan.price }}</span>
                </template>
              </div>
            </div>
            <div class="mb-24">
              <h6 class="font-bold mb-8">The number of products</h6>
              <div class="text-blue text-lg font-bold">{{ plan.count }}</div>
            </div>
            <div>
              <h6 class="font-bold mb-8">Services</h6>
              <ul class="text-sm text-grey-darker list-reset leading-md">
                <li v-for="service in plan.services" :key="service">{{ service }}</li>
              </ul>
            </div>
            <hr>
            <div class="mb-24 border-t border-grey-lighter pt-16 mt-16">
              <h6 class="font-bold mb-8">Add-on: traceability sticker</h6>
            </div>
            <button class="btn btn-block btn-solid btn-blue gradient-btn" @click="openContactFormWithPlan($event, plan)">
              <span>Buy and download</span>
            </button>
          </div>
        </div>
      </template>
    </div>
  </template>
  <template v-if="nowTab === 2">
    <div class="bg-white p-16 rounded">
      <h3 class="text-center font-bold mt-8 mb-16">IoT device (outright purchase or leasing plan)</h3>
      <div class="flex flex-wrap justify-center">
        <template v-for="(item, index) in config.IoTs">
          <div class="separate-vertical sm:w-1/2 lg:w-1/3 px-8" :key="index">
            <h5 class="font-bold">{{ item.name }}</h5>
            <div class="text-xs leading-xs mt-4 mb-16">{{ item.description }}</div>
            <img :src="item.cover">
          </div>
        </template>
      </div>
      <div class="text-center text-4xl font-bold my-16">
        +
      </div>
      <div class="flex flex-wrap  justify-center">
        <template v-for="(plan, index) in config.plans">
          <div :key="index" class="w-full mb-8 lg:mb-0 sm:w-1/2 lg:w-1/3 px-8">
            <div class="priceTable__item text-left border-b border-grey-lightest md:border-b-0 p-8 md:shadow-none" :class="{'md:border-r mr-0': index < config.plans.length - 1}">
              <h3 class="font-bold">{{ plan.name }}</h3>
              <div>
                <div  class="text-blue mt-16 mb-32 font-bold">
                  <template v-if="typeof plan.price === 'number'">
                    USD <span class="text-4xl font-bold">{{ plan.price | toThousands }}</span> / month
                  </template>
                  <template v-else>
                    <span class="text-2xl leading-2xl font-bold">{{ plan.price }}</span>
                  </template>
                </div>
              </div>
              <div class="mb-24">
                <h6 class="font-bold mb-8">The number of products</h6>
                <div class="text-blue text-lg font-bold">{{ plan.count }}</div>
              </div>
              <div>
                <h6 class="font-bold mb-8">Services</h6>
                <ul class="text-sm text-grey-darker list-reset leading-md">
                  <li v-for="service in plan.services" :key="service">{{ service }}</li>
                </ul>
              </div>
              <hr>
              <div class="mb-24 pt-16 mt-16">
                <h6 class="font-bold mb-8">Add-on: traceability sticker</h6>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="text-right">
        <button class="btn btn-solid btn-blue gradient-btn" @click="openContactFormWithPlan()">Apply</button>
      </div>
    </div>
  </template>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import config from './configs/en'

export default {
  props: {
    nowTab: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      config
    }
  },
  filters: {
    toThousands: function (val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  methods: {
    ...mapActions([
      'openContactForm'
    ]),
    openContactFormWithPlan (event, plan) {
      // plan ? this.openContactForm({ from: 'Agriculture', plan: plan.name }) : this.openContactForm({ from: 'Agriculture' })
      this.openContactForm({ from: 'Agriculture' })
    }
  }
}
</script>
